import { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'

import styled from 'styled-components'

import { selectDevice } from 'hooks/deviceInfo'
import { useSelector } from 'react-redux'
import { timerAlert } from 'util/util'

import { useSpring, animated, useTransition } from '@react-spring/web'

import Bg from 'assets/img/cps/bgList1.png'
import VolleyBallBg from 'assets/img/cps/indoor_vb.png'
import AllRounterBg from 'assets/img/cps/indoor_ar.png'

import { apiSaveLog, apiThumbnailList } from 'api/api'

import NavigateButton from 'components/NavigateButton'

const Container = styled.div`
	background-image: url(${Bg});
	background-size: cover;
	background-repeat: no-repeat;
	background-position: center;
	padding: 35px 185px 35px 164px;
	position: relative;
`

const MenuContainer = styled.div`
	position: relative;
	padding-top: calc(220px - 35px);
	.itemInner {
		display: flex;
		justify-content: center;
		align-items: top;
		width: 1570px;
	}
	.itemLeftWrapper {
		display: flex;
		margin-right: 110px;
		width: 1000px;
		background: url(${VolleyBallBg}) no-repeat 0 0;
	}
	.itemFaster {
		position: relative;
		width: 50%;
		min-height: 460px;
		padding-top: 495px;
		.listItem {
			width: 450px;
		}
	}
	.itemHigher {
		position: relative;
		width: 50%;
		min-height: 460px;
		padding-top: 495px;
		display: flex;
		justify-content: center;
		.listItem {
			width: 360px;
			padding-left: 100px;
		}
	}
	.itemArounder {
		position: relative;
		width: 493px;
		min-height: 460px;
		padding-top: 495px;
		background: url(${AllRounterBg}) no-repeat 0 0;
		.listItem {
			width: 360px;
			padding-left: 180px;
		}
	}
	.listItem {
		display: flex;
		flex-wrap: wrap;
		transform: translateY(-40px);
		li {
			display: flex;
			flex-wrap: wrap;
			justify-content: center;
			width: 100%;
			padding: 0 10px;
			img {
				max-width: 260px;
			}
		}
	}
`

const PageTitle = styled.div`
	position: absolute;
	top: 68px;
	left: 58px;
	font-size: 40px;
	color: #2f302f;
	width: 250px;
	text-align: center;
	line-height: 1;
	.bar {
		width: 100%;
		height: 10px;
		background: #515151;
		margin: 15px 0;
	}
	span {
		font-size: 50px;
	}
`

const IndoorList = () => {
	const location = useLocation()
	const deviceInfo = useSelector(selectDevice)
	const navigate = useNavigate()

	const [baseLineList, setBaseLineList] = useState<any[]>([])
	const [allCourtList, setAllCourtList] = useState<any[]>([])
	const [bestOfBothList, setBestOfBothList] = useState<any[]>([])

	const [fasterList, setFasterList] = useState<any[]>([])
	const [higherList, setHigherList] = useState<any[]>([])
	const [arounder, setArounder] = useState<any[]>([])

	const menuMove1 = useSpring({
		from: { opacity: 0, y: 100 },
		to: { opacity: 1, y: 0 },
		delay: 100,
	})

	const menuMove2 = useSpring({
		from: { opacity: 0, y: 100 },
		to: { opacity: 1, y: 0 },
		delay: 200,
	})

	const menuMove3 = useSpring({
		from: { opacity: 0, y: 100 },
		to: { opacity: 1, y: 0 },
		delay: 300,
	})

	const titleMove = useSpring({
		from: { opacity: 0, x: -100 },
		to: { opacity: 1, x: 0 },
		delay: 0,
	})

	const titleMove2 = useSpring({
		from: { opacity: 0, x: 100 },
		to: { opacity: 1, x: 0 },
		delay: 0,
	})

	const onTouchEnd = (e: any) => {
		console.log(e)
		navigate(`/prun/speed/view`, {
			state: { item: location.state?.item },
		})
	}

	const onItemClick = (item: any, itemType: any, bgColor: string) => {
		item.subsortId = location.state.item.subsortId
		item.pageTitle = itemType
		item.bgColor = bgColor

		const logRequest = {
			userId: deviceInfo.userId,
			kioskDeviceId: deviceInfo.kioskDeviceId,
			categoryId: deviceInfo.categoryId,
			productId: item.productId,
			subSortId: location.state?.item?.subsortId,
		}
		if (
			logRequest.userId &&
			logRequest.kioskDeviceId &&
			logRequest.categoryId &&
			logRequest.productId &&
			logRequest.subSortId
		) {
			apiSaveLog(logRequest)
		}

		navigate(`/cps/indoor/view`, { state: { item } })
	}

	useEffect(() => {
		const { item } = location.state
		console.log(item)
		if (item) {
			const request = {
				subsortId: item.subsortId,
				kioskDeviceId: deviceInfo.kioskDeviceId,
			}
			apiThumbnailList(request).then((res) => {
				console.log(res)
				res.forEach((element: any) => {
					if (element.name.startsWith('NET')) {
						setFasterList((prev) => [...prev, element])
					} else if (element.name.startsWith('RIVRE')) {
						setArounder((prev) => [...prev, element])
					} else {
						setHigherList((prev) => [...prev, element])
					}
				})
			})
		}
		const disablePinchZoom = (e: any) => {
			if (e.touches.length > 1) {
				e.preventDefault()
			}
		}
		document.addEventListener('touchmove', disablePinchZoom, { passive: false })
		return () => {
			document.removeEventListener('touchmove', disablePinchZoom)
		}
	}, [])

	return (
		<Container className="container">
			<PageTitle>
				<animated.div style={titleMove}>
					<span className="asics-bold-italic">INDOOR</span>
				</animated.div>
			</PageTitle>
			<MenuContainer>
				<animated.div
					className="itemInner"
					style={menuMove1}
				>
					<div className="itemLeftWrapper">
						<div className="itemFaster">
							<ul className="listItem">
								{fasterList
									.filter((item: any) => item.pdbkProductId === undefined)
									.map((item: any, index: number) => {
										return (
											<li key={item.fileId}>
												<img
													src={`${process.env.REACT_APP_HOST}/file/view/id/${item.fileId}`}
													alt="heritage"
													onClick={() => onItemClick(item, 'INDOOR', '#494949')}
												/>
											</li>
										)
									})}
							</ul>
						</div>
						<div className="itemHigher">
							<ul className="listItem">
								{higherList
									.filter((item: any) => item.pdbkProductId === undefined)
									.map((item: any, index: number) => {
										return (
											<li key={item.fileId}>
												<img
													src={`${process.env.REACT_APP_HOST}/file/view/id/${item.fileId}`}
													alt="heritage"
													onClick={() => onItemClick(item, 'INDOOR', '#8BC191')}
												/>
											</li>
										)
									})}
							</ul>
						</div>
					</div>
					<div className="itemArounder">
						<ul className="listItem">
							{arounder
								.filter((item: any) => item.pdbkProductId === undefined)
								.map((item: any, index: number) => {
									return (
										<li key={item.fileId}>
											<img
												src={`${process.env.REACT_APP_HOST}/file/view/id/${item.fileId}`}
												alt="heritage"
												onClick={() => onItemClick(item, 'INDOOR', '#494949')}
											/>
										</li>
									)
								})}
						</ul>
					</div>
				</animated.div>
			</MenuContainer>
			<NavigateButton />
		</Container>
	)
}

export default IndoorList
